import {
    USER_APP_ACTIVITY,
    USER_APP_VISIBLILTY
} from 'store/mutation-types'

export default (store) => {
    /**
     * The following code will be
     * executed at store initialisation
     */
    let hidden = "hidden",
        timer = null

    // Standards:
    if (hidden in document)
        document.addEventListener("visibilitychange", onchange)
    else if ((hidden = "mozHidden") in document)
        document.addEventListener("mozvisibilitychange", onchange)
    else if ((hidden = "webkitHidden") in document)
        document.addEventListener("webkitvisibilitychange", onchange)
    else if ((hidden = "msHidden") in document)
        document.addEventListener("msvisibilitychange", onchange)
    // IE 9 and lower:
    else if ("onfocusin" in document)
        document.onfocusin = document.onfocusout = onchange
    // All others:
    else
        window.onpageshow = window.onpagehide
            = window.onfocus = window.onblur = onchange

    /**
     * automaticly mutates `isVisible` state accordingly
     * @param  {Object} evt event object
     */
    function onchange(evt) {
        const v = "visible", h = "hidden",
            evtMap = {
                focus: true,
                focusin: true,
                pageshow: true,
                blur: false,
                focusout: false,
                pagehide: false
            }

        evt = evt || window.event
        if (evt.type in evtMap)
            store.commit(USER_APP_VISIBLILTY, evtMap[evt.type])
        else
            store.commit(USER_APP_VISIBLILTY, !this[hidden])
    }

    // set the initial state
    // (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined)
        onchange({type: document[hidden] ? "blur" : "focus"})
    /**
     * The following code will listen to
     * `USER_APP_VISIBLILTY` mutation type
     * and will start an inactivity timer
     */
    store.subscribe((mutation, state) => {
        // called after every mutation.

        // nothing to do if user is not logged or active
        // when application visibility changed
        if (!(state.isLoggedIn && state.isActive))
            return;
        // The mutation comes in the format of { type, payload }.
        const {type, payload} = mutation

        // this piece of code is observing
        // if a mutation just setted isVisible to `false`
        if (type === USER_APP_VISIBLILTY) {

            // payload is `state.isVisible` value
            if (!payload) {
                let startTime = Date.now()

                // _.isNull(timer) || clearInterval(timer)
                timer = setInterval(_ => {
                    const delta = Date.now() - startTime,
                        minutesElapsed = delta / 60000
                    console.log(`${minutesElapsed} minutes elapsed since App is not visible.`)
                    if (minutesElapsed >= 5) {
                        store.commit(USER_APP_ACTIVITY, false)
                        clearInterval(timer)
                    }
                }, 10000)
            } else {
                clearInterval(timer)
            }
        }
    })
}



// WEBPACK FOOTER //
// ./client/utils/activity-detector.js